import React, { useState, useEffect, useRef } from 'react';
import { walletAmount, BbIcon, RobuxIcon, WalletValue, useAuth } from '../context/AuthContext';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, TrendingUp, BarChart3, Circle, History, ChevronLeft, ChevronRight } from 'lucide-react';
import { toast } from 'sonner';
import { useChatLayout } from '../context/ChatLayoutContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

/* ⚠️ Aynı anda ekranda tutulacak en fazla top. Telefonda her top ~17 tık
   zamanlayıcısı ve bir animasyon düğümü demek; sınırsız bırakmak sekmeyi
   düşürüyordu. */
const MAX_CONCURRENT_BALLS = 12;

// ==========================================
// YENİ: K, M, B FORMATLAYICILARI (ÇİFT YÖNLÜ)
// ==========================================
const parseAmount = (valStr) => {
  if (!valStr) return 0;
  // ⚠️ BİNLİK AYIRICI TEMİZLENMELİ. formatAmount() büyük sayıları
  // toLocaleString ile üretiyor ("1,457,545"); parseFloat virgülde durup
  // 1 döndürüyordu. MAX butonuna basan kullanıcı 1 birim bahis oynuyordu.
  let str = valStr.toString().trim().toLowerCase().replace(/[,\s]/g, '');
  let multiplier = 1;
  if (str.endsWith('k')) { multiplier = 1000; str = str.slice(0, -1); }
  else if (str.endsWith('m')) { multiplier = 1000000; str = str.slice(0, -1); }
  else if (str.endsWith('b')) { multiplier = 1000000000; str = str.slice(0, -1); }
  
  const parsedValue = parseFloat(str);
  return isNaN(parsedValue) ? 0 : Math.floor(parsedValue * multiplier);
};

const formatAmount = (amount) => {
  if (amount === undefined || amount === null || amount === 0) return '';
  if (amount >= 1000000) return amount.toLocaleString();
  if (amount >= 1000) return parseFloat((amount / 1000).toFixed(2)) + 'K';
  return amount.toString();
};

const PLINKO_MULTIPLIERS = {
  "low": {
    8:  [5.8, 2.2, 1.1, 0.93, 0.44, 0.93, 1.1, 2.2, 5.8],
    12: [10, 3.1, 1.6, 1.4, 1.1, 0.92, 0.46, 0.92, 1.1, 1.4, 1.6, 3.1, 10],
    16: [16, 9.1, 2.0, 1.4, 1.4, 1.2, 1.1, 0.91, 0.46, 0.91, 1.1, 1.2, 1.4, 1.4, 2.0, 9.1, 16],
  },
  "medium": {
    8:  [13, 3.0, 1.3, 0.69, 0.27, 0.69, 1.3, 3.0, 13],
    12: [31, 13, 3.8, 1.8, 1.1, 0.57, 0.25, 0.57, 1.1, 1.8, 3.8, 13, 31],
    16: [108, 40, 9.8, 4.9, 2.9, 1.5, 0.98, 0.49, 0.18, 0.49, 0.98, 1.5, 2.9, 4.9, 9.8, 40, 108],
  },
  "high": {
    8:  [29, 3.9, 1.5, 0.3, 0.07, 0.3, 1.5, 3.9, 29],
    12: [167, 24, 7.9, 2.0, 0.69, 0.2, 0.06, 0.2, 0.69, 2.0, 7.9, 24, 167],
    16: [979, 127, 25, 8.8, 3.9, 2.0, 0.2, 0.2, 0.07, 0.2, 0.2, 2.0, 3.9, 8.8, 25, 127, 979],
  },
};

export const Plinko = () => {
  const { user, token, isAuthenticated, balance, fmtMoney, wallet, betToRaw, rawToBet, betLimits } = useAuth();
  const [betAmount, setBetAmount] = useState('');
  // 💬 Aç/kapa durumu paylaşımlı: sayfa değişse de korunur.
  const { chatOpen } = useChatLayout();
  const [rows, setRows] = useState(12);
  const [risk, setRisk] = useState('medium');
  const [balls, setBalls] = useState([]);
  
  const [serverSeed, setServerSeed] = useState('');
  const [lastWin, setLastWin] = useState(null);
  const [history, setHistory] = useState([]); 
  
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  /* ⚠️⚠️ SES HAVUZU — her tıkta YENİ nesne yaratmak yerine sabit sayıda
     öğe döngüsel kullanılır. (Roulette ve CaseOpening'de zaten bu desen var;
     Plinko o düzeltmeyi almamıştı.)

     Eski hâli her tıkta cloneNode() ile yeni bir Audio üretiyordu: 16 sıralı
     bir topta 17 nesne, hızlı 10 topta 170 nesne. Hiçbiri temizlenmiyordu.
     iOS'un eşzamanlı ses sınırı ~16 olduğu için sekme ses altyapısı taşıyor
     ve sayfa düşüyordu; dahası biten topların sesleri çalmaya devam
     ediyordu. */
  const audioPool = useRef([]);
  const poolIdx = useRef(0);

  /* ⚠️ TÜM ZAMANLAYICILAR TAKİP EDİLİR. Tık ve top-silme setTimeout'ları
     hiçbir yerde saklanmıyordu, dolayısıyla İPTAL EDİLEMİYORDU: kullanıcı
     sayfadan çıksa bile tık sesleri BAŞKA SAYFADA çalmaya devam ediyor ve
     setBalls sökülmüş bileşende çağrılıyordu. */
  const timersRef = useRef(new Set());
  const aliveRef = useRef(true);

  const track = (fn, ms) => {
    const id = setTimeout(() => {
      timersRef.current.delete(id);
      if (aliveRef.current) fn();
    }, ms);
    timersRef.current.add(id);
    return id;
  };

  useEffect(() => {
    if (typeof Audio !== "undefined") {
      const pool = [];
      for (let i = 0; i < 6; i++) {
        const a = new Audio('/reel_tick.mp3');
        a.preload = 'auto';
        a.volume = 0.15;
        pool.push(a);
      }
      audioPool.current = pool;
    }

    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      /* ⚠️ Sökülürken HER ŞEY durur: bekleyen zamanlayıcılar iptal, çalan
         sesler durdurulur. Bu olmadan kullanıcı Plinko'dan çıktıktan sonra
         da tık sesi duyuyordu. */
      aliveRef.current = false;
      timersRef.current.forEach(clearTimeout);
      timersRef.current.clear();
      audioPool.current.forEach((a) => {
        try { a.pause(); a.currentTime = 0; } catch (e) {}
      });
      audioPool.current = [];
    };
  }, []);

  const playTickSound = () => {
    const pool = audioPool.current;
    if (!pool.length) return;
    const audio = pool[poolIdx.current];
    poolIdx.current = (poolIdx.current + 1) % pool.length;
    try {
      audio.currentTime = 0;
      const p = audio.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } catch (e) {}
  };

  // YENİ: K, M, B Destekli Hızlı Buton Fonksiyonları
  const handleBetChange = (val) => setBetAmount(val);
  const addBetAmount = (val) => {
    const current = parseAmount(betAmount);
    setBetAmount(String(current + val));
  };
  const multiplyBet = (multiplier) => {
    const current = parseAmount(betAmount);
    setBetAmount(String(Math.floor(current * multiplier)));
  };

  const dropBall = async () => {
    // 🎯 Kullanıcı AKTİF CÜZDANIN biriminde yazar (Robux → site birimi,
    // BB Coin → BB). betToRaw saklama birimine çevirir: BB'de ×1000.
    // Bu satır olmadan "10" yazan oyuncu 10 mili-BB (0,01 BB) oynardı.
    const amount = betToRaw(parseAmount(betAmount)); // YENİ: Stringi Integer'a çeviriyoruz
    
    if (!isAuthenticated) return toast.error("Please log in first!");
    // ⚠️ Limitler cüzdana göre; "1 – 100.000" SİTE birimidir ve
    // BB Coin bahislerini haksız yere reddederdi.
    if (!amount || amount < betLimits.min_bet || amount > betLimits.max_bet) {
      return toast.error(`Bet must be between ${walletAmount(betLimits.min_bet, wallet)} and ${walletAmount(betLimits.max_bet, wallet)}.`);
    }
    // 🍀 AKTİF CÜZDANIN bakiyesiyle karşılaştır (LC'de mili-LC).
    if (amount > balance) return toast.error("Insufficient balance!");

    try {
      const response = await axios.post(`${API}/game/plinko/drop`, {
        amount: amount,
        rows: rows,
        risk: risk
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const { path, multiplier, win_amount, server_seed } = response.data;
      
      const newBall = {
        id: Date.now() + Math.random(),
        path: path,
        multiplier: multiplier,
        win_amount: win_amount
      };

      setServerSeed('');
      /* ⚠️ EŞZAMANLI TOP SINIRI. Hızlı tıklamada dizi sınırsız büyüyor ve
         her top kendi tık zamanlayıcılarını kuruyordu; telefonda hem
         animasyon hem ses altyapısı boğuluyordu. En eskiler düşürülür —
         onlar zaten ekranın altına ulaşmış ve sonucu işlenmiş olur. */
      setBalls(prev => [...prev, newBall].slice(-MAX_CONCURRENT_BALLS));
      
      const dropDuration = (rows * 0.15) * 1000;

      /* ⚠️ track(): zamanlayıcı kaydedilir ve sökülmede iptal edilir.
         Ayrıca aliveRef kontrolü sayesinde sayfadan çıkıldıysa geri çağırma
         HİÇ çalışmaz — eskiden tık sesleri başka sayfada çalıyordu. */
      for (let i = 0; i <= rows; i++) {
        track(playTickSound, (i * 0.15) * 1000);
      }

      track(() => {
        setLastWin({ amount: win_amount, mult: multiplier });
        setServerSeed(server_seed);
        setHistory(prev => [{ id: newBall.id, mult: multiplier }, ...prev].slice(0, 10));

        track(() => {
          setBalls(prev => prev.filter(b => b.id !== newBall.id));
        }, 3000);
      }, dropDuration);

    } catch (error) {
      if (error.response && error.response.status === 429) {
        toast.error("Too fast! Please slow down a bit. 🐢");
      } else {
        toast.error(error.response?.data?.detail || error.response?.data?.error || "An error occurred!");
      }
    }
  };

  const horizontalSpacing = 36; 
  const verticalSpacing = 36; 
  const pinSize = 6;

  const getScale = () => {
    if (screenWidth < 400) { 
      if (rows === 16) return 0.42;
      if (rows === 12) return 0.55;
      return 0.75;
    }
    if (screenWidth < 768) { 
      if (rows === 16) return 0.48;
      if (rows === 12) return 0.65;
      return 0.85;
    }
    if (screenWidth < 1024) { 
      if (rows === 16) return 0.55;
      if (rows === 12) return 0.75;
      return 0.95;
    }
    if (rows === 16) return 0.65;
    if (rows === 12) return 0.85;
    return 1;
  };

  const renderBoard = () => {
    const pins = [];
    for (let r = 0; r < rows; r++) {
      for (let i = 0; i <= r; i++) {
        const xPos = (2 * i - r) * (horizontalSpacing / 2);
        pins.push(
          <div
            key={`pin-${r}-${i}`}
            className="absolute bg-[#B059E8] rounded-full shadow-[0_0_8px_rgba(176,89,232,0.8)]"
            style={{
              width: pinSize,
              height: pinSize,
              left: `calc(50% + ${xPos}px)`,
              top: `${r * verticalSpacing + 30}px`,
              transform: 'translate(-50%, -50%)'
            }}
          />
        );
      }
    }
    return pins;
  };

  const getSlotColor = (mult) => {
    if (mult >= 10) return 'bg-rose-500 shadow-[0_0_15px_rgba(244,63,94,0.4)] text-white border-rose-400';
    if (mult >= 2) return 'bg-amber-500 shadow-[0_0_15px_rgba(245,158,11,0.4)] text-white border-amber-400';
    if (mult >= 1) return 'bg-[#16A34A] shadow-[0_0_15px_rgba(22,163,74,0.4)] text-white border-[#2ecf6e]';
    return 'bg-[#15171a] shadow-inner text-zinc-400 border-[#2A2D31]';
  };

  const renderSlots = () => {
    const multipliers = PLINKO_MULTIPLIERS[risk][rows];
    return multipliers.map((mult, i) => {
      const xPos = (2 * i - rows) * (horizontalSpacing / 2);
      return (
        <div
          key={`slot-${i}`}
          className={`absolute rounded-md flex items-center justify-center font-bold text-[11px] shadow-lg border-2 transition-transform hover:scale-110 ${getSlotColor(mult)}`}
          style={{
            width: horizontalSpacing - 4, 
            height: 26,
            left: `calc(50% + ${xPos}px)`,
            top: `${rows * verticalSpacing + 30 + 10}px`,
            transform: 'translate(-50%, -50%)'
          }}
        >
          {mult}x
        </div>
      );
    });
  };

  const renderBalls = () => {
    return balls.map((ball) => {
      const animationFrames = [];
      const easings = ["easeIn"]; 

      let currentX = 0;
      let currentY = 30; 
      let currentSum = 0;

      animationFrames.push({ x: 0, y: -10 }); 
      animationFrames.push({ x: 0, y: currentY }); 

      ball.path.forEach((direction, r) => {
        currentSum += direction;
        
        const nextX = (2 * currentSum - (r + 1)) * (horizontalSpacing / 2);
        const isLast = r === rows - 1;
        const nextY = isLast ? (rows * verticalSpacing + 30 + 10) : ((r + 1) * verticalSpacing + 30);

        const midX = (currentX + nextX) / 2;
        const midY = currentY - 14; 

        animationFrames.push({ x: midX, y: midY });
        animationFrames.push({ x: nextX, y: nextY });

        easings.push("easeOut", "easeIn");

        currentX = nextX;
        currentY = nextY;
      });

      return (
        <motion.div
          key={ball.id}
          className="absolute w-5 h-5 bg-gradient-to-b from-[#d29bff] to-[#B059E8] rounded-full shadow-[0_0_20px_rgba(176,89,232,0.9)] z-20 border-2 border-white/50"
          initial={{ x: 0, y: -10, opacity: 1, scale: 0.8 }}
          animate={{
            x: animationFrames.map(f => f.x),
            y: animationFrames.map(f => f.y)
          }}
          transition={{
            duration: rows * 0.15,
            ease: easings, 
            times: animationFrames.map((_, i) => i / (animationFrames.length - 1))
          }}
          style={{
            left: '50%',
            top: '0px',
            marginLeft: '-10px',
            marginTop: '-10px'
          }}
        />
      );
    });
  };

  return (
    <div className="min-h-screen bg-[#0E0F11]" data-testid="plinko-page">
      <div className="max-w-[1800px] mx-auto px-4 pt-24 pb-8">
        <div className={`flex flex-col lg:flex-row gap-6 transition-[padding] duration-300 ${chatOpen ? 'md:pl-[340px] lg:pl-[370px]' : ''}`}>
          
          {/* 💬 Sohbet App.js'te TEK kopya render ediliyor (ChatDock).
              Sayfa-içi kopya kaldırıldı: her gezinmede WebSocket kopup
              yeniden bağlanıyor ve 4 HTTP isteği tekrar atılıyordu. */}
          <main className="flex-1 flex flex-col lg:flex-row gap-6 min-w-0 lg:h-[calc(100vh-120px)]">
            
            {/* SOL SÜTUN: KONTROLLER */}
            <div className="w-full lg:w-80 flex-shrink-0 flex flex-col gap-4 h-full">
              <div className="bg-[#1A1D20] rounded-2xl border border-[#2A2D31] p-4 shadow-lg h-full flex flex-col">
                <div className="space-y-6 flex-1">
                  
                  <div>
                    <label className="flex items-center gap-2 text-xs text-zinc-400 font-bold mb-2">
                        <TrendingUp className="w-4 h-4" /> RISK LEVEL
                    </label>
                    <div className="grid grid-cols-3 gap-2">
                      {['low', 'medium', 'high'].map((r) => (
                        <button
                          key={r}
                          onClick={() => setRisk(r)}
                          className={`py-2 rounded-lg text-[10px] md:text-xs font-bold uppercase transition-all ${
                            risk === r 
                            ? 'bg-[#B059E8] text-white shadow-[0_0_15px_rgba(236,72,153,0.4)]' 
                            : 'bg-[#2A2D31]/50 text-zinc-400 hover:bg-[#33363b] hover:text-white disabled:opacity-50'
                          }`}
                        >
                          {r}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="flex items-center gap-2 text-xs text-zinc-400 font-bold mb-2">
                        <BarChart3 className="w-4 h-4" /> ROWS
                    </label>
                    <div className="grid grid-cols-3 gap-2">
                      {[8, 12, 16].map((num) => (
                        <button
                          key={num}
                          onClick={() => setRows(num)}
                          className={`py-2 rounded-lg text-[10px] md:text-xs font-bold transition-all ${
                            rows === num 
                            ? 'bg-[#B059E8] text-white shadow-[0_0_15px_rgba(176,89,232,0.4)]' 
                            : 'bg-[#2A2D31]/50 text-zinc-400 hover:bg-[#33363b] hover:text-white disabled:opacity-50'
                          }`}
                        >
                          {num} Rows
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* BAHİS GİRİŞİ VE BUTONLAR */}
                  <div>
                    <label className="text-xs text-zinc-400 font-bold mb-1.5 block">Bet Amount</label>
                    <div className="relative mb-3">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                        {/* Birim öneki AKTİF cüzdana göre; sabit "$" BB tarafında yanlıştı. */}
                        {wallet === 'lc' ? <BbIcon size={15} /> : <RobuxIcon size={15} />}
                      </div>
                      <input
                        type="text" // YENİ: type number yerine text yapıldı
                        value={betAmount}
                        onChange={(e) => handleBetChange(e.target.value)}
                        className="w-full bg-[#15171a] border border-[#2A2D31] rounded-xl py-3 pl-10 pr-4 text-white font-bold outline-none focus:border-[#B059E8] transition-colors uppercase"
                        placeholder="1"
                      />
                    </div>
                    <div className="grid grid-cols-4 gap-2">
                      <button onClick={() => addBetAmount(10)} className="py-2 text-xs font-bold text-zinc-300 bg-[#2A2D31]/50 hover:bg-[#33363b] rounded-lg transition-colors">+10</button>
                      <button onClick={() => multiplyBet(0.5)} className="py-2 text-xs font-bold text-zinc-300 bg-[#2A2D31]/50 hover:bg-[#33363b] rounded-lg transition-colors">1/2</button>
                      <button onClick={() => multiplyBet(2)} className="py-2 text-xs font-bold text-zinc-300 bg-[#2A2D31]/50 hover:bg-[#33363b] rounded-lg transition-colors">2x</button>
                      <button onClick={() => setBetAmount(String(rawToBet(balance || 0)))} className="py-2 text-xs font-bold text-[#c98bf0] bg-[#B059E8]/20 border border-[#B059E8]/30 hover:bg-[#B059E8]/40 rounded-lg transition-colors">MAX</button>
                    </div>
                  </div>
                </div>

                <div className="mt-auto pt-6">
                    <button 
                      onClick={dropBall}
                      disabled={!betAmount}
                      className="w-full py-4 rounded-xl font-heading font-bold text-lg uppercase tracking-wider transition-all shadow-lg bg-gradient-to-r from-[#16A34A] to-[#2ecf6e] hover:from-[#2ecf6e] hover:to-[#5ee08f] text-white disabled:opacity-50 disabled:grayscale transform active:scale-95"
                    >
                      DROP BALL
                    </button>
                </div>
              </div>
            </div>

            {/* SAĞ SÜTUN: OYUN TAHTASI */}
            <div className="flex-1 flex flex-col items-center bg-[#1A1D20] rounded-2xl border border-[#2A2D31] shadow-2xl relative overflow-x-hidden overflow-y-auto h-full p-4 lg:p-6 scrollbar-thin">
              
              <div className="absolute top-4 left-4 md:top-6 md:left-6 flex flex-col z-10">
                <div className="flex items-center gap-2 mb-2">
                    <Circle className="w-5 h-5 text-[#B059E8]" />
                    <span className="text-zinc-400 font-bold uppercase tracking-widest text-sm">Plinko</span>
                </div>
                {lastWin && (
                  <span className={`text-xl md:text-2xl font-heading font-bold ${lastWin.mult >= 2 ? 'text-[#2ecf6e]' : 'text-zinc-500'} drop-shadow-lg`}>
                    Last Drop: {lastWin.mult}x
                  </span>
                )}
              </div>

              {/* SAĞ ÜST GEÇMİŞ (HISTORY) SÜTUNU */}
              <div className="absolute top-4 right-4 md:top-6 md:right-6 flex flex-col items-center z-30 pointer-events-none">
                <span className="text-zinc-500 font-bold flex items-center gap-1 uppercase tracking-widest text-[9px] md:text-[10px] mb-2">
                  <History className="w-3 h-3" /> Recent
                </span>
                
                <div className="flex flex-col gap-1.5 overflow-hidden max-h-[250px] md:max-h-[300px] [mask-image:linear-gradient(to_bottom,white_70%,transparent_100%)] p-1">
                  <AnimatePresence>
                    {history.map((item) => (
                       <motion.div
                          layout 
                          key={item.id}
                          initial={{ opacity: 0, y: -20, scale: 0.8 }}
                          animate={{ opacity: 1, y: 0, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.15 } }} 
                          className={`w-10 h-7 md:w-12 md:h-8 rounded-md flex-shrink-0 flex items-center justify-center font-bold text-[10px] md:text-xs shadow-lg border-2 ${getSlotColor(item.mult)}`}
                       >
                          {item.mult}x
                       </motion.div>
                    ))}
                  </AnimatePresence>
                </div>
              </div>

              <div 
                  className="relative w-full max-w-[700px] flex justify-center mt-12 md:mt-24 transition-transform duration-500"
                  style={{ 
                      transform: `scale(${getScale()})`, 
                      transformOrigin: 'center top' 
                  }}
              >
                  <div className="relative" style={{ height: (rows + 1) * verticalSpacing + 60 }}>
                      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[300px] h-full bg-[#B059E8]/5 blur-[60px] pointer-events-none" />
                      {renderBoard()}
                      {renderSlots()}
                      {renderBalls()}
                  </div>
              </div>

              <div className="absolute bottom-4 left-4 right-4 flex flex-col md:flex-row items-center justify-between gap-2 text-[10px] md:text-xs text-zinc-500 mm-num pointer-events-none px-2 mt-10">
                <div className="flex items-center gap-1.5">
                  <ShieldCheck className="w-4 h-4 text-[#16A34A]" />
                  <span>Provably Fair</span>
                </div>
                {serverSeed && (
                  <div className="flex gap-4 w-full md:w-auto overflow-hidden opacity-70">
                      <span className="truncate text-[#16A34A]" title={serverSeed}>
                        <span className="text-[#15913f]">Seed:</span> {serverSeed.substring(0, 20)}...
                      </span>
                  </div>
                )}
              </div>

            </div>
          </main>
        </div>
      </div>
    </div>
  );
};